import React, { useState } from 'react';
import { ArrowLeft } from 'lucide-react';


const languages = [
  { label: 'English', value: 'English' },
  { label: 'తెలుగు (Telugu)', value: 'తెలుగు' },
  { label: 'हिंदी (Hindi)', value: 'हिंदी' },
];

const SettingsScreen = ({ onBack }) => {
  const [selectedLanguage, setSelectedLanguage] = useState('English');
  const [isLangModalOpen, setIsLangModalOpen] = useState(false);

  const handleSelectLanguage = (lang) => {
    setSelectedLanguage(lang);
    setTimeout(() => setIsLangModalOpen(false), 300);
  };

  return (
    <div className="max-w-[480px] mx-auto pt-4 pb-8">
      {/* Top Bar */}
      <div className="flex items-center gap-3 mb-6">
        <button
          className="p-2 bg-[#222] border border-[#2b2b2b] hover:bg-[#2b2b2b] rounded-lg text-gray-400 hover:text-white transition-all"
          onClick={onBack}
        >
          <ArrowLeft size={18} />
        </button>
        <span className="text-[20px] font-medium text-white">Settings</span>
      </div>

      {/* Notifications */}
      <div className="text-[11px] font-medium text-[#888] uppercase tracking-[0.6px] mt-5 mb-2 first-of-type:mt-0">Notifications</div>
      <div className="bg-[#101010] border-[0.5px] border-[#2b2b2b] rounded-[12px] overflow-hidden">
        {/* Check-in confirmation */}
        <div
          className="flex items-center justify-between p-3.5 border-b-[0.5px] border-[#2b2b2b] cursor-pointer gap-3 transition-colors hover:bg-[#181818] opacity-60"
          onClick={() => alert("This feature is under development and will be available in a future update.")}
        >
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-[8px] flex items-center justify-center text-[14px] shrink-0 bg-[#181818]">🔔</div>
            <div className="flex flex-col">
              <div className="text-[13px] font-medium text-white">Check-in confirmation</div>
              <div className="text-[11px] text-[#888] mt-0.5">Status: <span className="text-yellow-500 italic font-medium">Coming Soon</span></div>
            </div>
          </div>
          <div className="w-[44px] h-6 rounded-[12px] border-[0.5px] relative transition-colors shrink-0 bg-[#333] border-[#444] opacity-50 cursor-not-allowed">
            <div className="w-[18px] h-[18px] rounded-full bg-gray-500 absolute top-[2px] left-[3px]" />
          </div>
        </div>

        {/* Membership expiry reminder */}
        <div
          className="flex items-center justify-between p-3.5 border-b-[0.5px] border-[#2b2b2b] cursor-pointer gap-3 transition-colors hover:bg-[#181818] opacity-60"
          onClick={() => alert("This feature is under development and will be available in a future update.")}
        >
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-[8px] flex items-center justify-center text-[14px] shrink-0 bg-[#181818]">⏰</div>
            <div className="flex flex-col">
              <div className="text-[13px] font-medium text-white">Membership expiry reminder</div>
              <div className="text-[11px] text-[#888] mt-0.5">Status: <span className="text-yellow-500 italic font-medium">Coming Soon</span></div>
            </div>
          </div>
          <div className="w-[44px] h-6 rounded-[12px] border-[0.5px] relative transition-colors shrink-0 bg-[#333] border-[#444] opacity-50 cursor-not-allowed">
            <div className="w-[18px] h-[18px] rounded-full bg-gray-500 absolute top-[2px] left-[3px]" />
          </div>
        </div>

        {/* Gym feed updates */}
        <div
          className="flex items-center justify-between p-3.5 border-b-[0.5px] border-[#2b2b2b] cursor-pointer gap-3 transition-colors hover:bg-[#181818] opacity-60"
          onClick={() => alert("This feature is under development and will be available in a future update.")}
        >
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-[8px] flex items-center justify-center text-[14px] shrink-0 bg-[#181818]">📢</div>
            <div className="flex flex-col">
              <div className="text-[13px] font-medium text-white">Gym feed updates</div>
              <div className="text-[11px] text-[#888] mt-0.5">Status: <span className="text-yellow-500 italic font-medium">Coming Soon</span></div>
            </div>
          </div>
          <div className="w-[44px] h-6 rounded-[12px] border-[0.5px] relative transition-colors shrink-0 bg-[#333] border-[#444] opacity-50 cursor-not-allowed">
            <div className="w-[18px] h-[18px] rounded-full bg-gray-500 absolute top-[2px] left-[3px]" />
          </div>
        </div>

        {/* Points and rewards */}
        <div
          className="flex items-center justify-between p-3.5 border-b-[0.5px] border-[#2b2b2b] cursor-pointer gap-3 transition-colors hover:bg-[#181818] opacity-60"
          onClick={() => alert("This feature is under development and will be available in a future update.")}
        >
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-[8px] flex items-center justify-center text-[14px] shrink-0 bg-[#181818]">⭐</div>
            <div className="flex flex-col">
              <div className="text-[13px] font-medium text-white">Points and rewards</div>
              <div className="text-[11px] text-[#888] mt-0.5">Status: <span className="text-yellow-500 italic font-medium">Coming Soon</span></div>
            </div>
          </div>
          <div className="w-[44px] h-6 rounded-[12px] border-[0.5px] relative transition-colors shrink-0 bg-[#333] border-[#444] opacity-50 cursor-not-allowed">
            <div className="w-[18px] h-[18px] rounded-full bg-gray-500 absolute top-[2px] left-[3px]" />
          </div>
        </div>

        {/* WhatsApp notifications */}
        <div
          className="flex items-center justify-between p-3.5 last:border-b-0 cursor-pointer gap-3 transition-colors hover:bg-[#181818] opacity-60"
          onClick={() => alert("This feature is under development and will be available in a future update.")}
        >
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-[8px] flex items-center justify-center text-[14px] shrink-0 bg-[#181818]">💬</div>
            <div className="flex flex-col">
              <div className="text-[13px] font-medium text-white">WhatsApp notifications</div>
              <div className="text-[11px] text-[#888] mt-0.5">Status: <span className="text-yellow-500 italic font-medium">Coming Soon</span></div>
            </div>
          </div>
          <div className="w-[44px] h-6 rounded-[12px] border-[0.5px] relative transition-colors shrink-0 bg-[#333] border-[#444] opacity-50 cursor-not-allowed">
            <div className="w-[18px] h-[18px] rounded-full bg-gray-500 absolute top-[2px] left-[3px]" />
          </div>
        </div>
      </div>

      {/* Account */}
      <div className="text-[11px] font-medium text-[#888] uppercase tracking-[0.6px] mt-5 mb-2">Account</div>
      <div className="bg-[#101010] border-[0.5px] border-[#2b2b2b] rounded-[12px] overflow-hidden">
        <div className="flex items-center justify-between p-3.5 border-b-[0.5px] border-[#2b2b2b] cursor-pointer gap-3 transition-colors hover:bg-[#181818]">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-[8px] flex items-center justify-center text-[14px] shrink-0 bg-[#181818]">📱</div>
            <div className="flex flex-col">
              <div className="text-[13px] font-medium text-white">Phone number</div>
              <div className="text-[11px] text-[#888] mt-0.5">Change your registered number</div>
            </div>
          </div>
          <div className="flex items-center gap-2 shrink-0"><span className="text-[13px] text-[#888]">›</span></div>
        </div>
        <div className="flex items-center justify-between p-3.5 last:border-b-0 cursor-pointer gap-3 transition-colors hover:bg-[#181818]">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-[8px] flex items-center justify-center text-[14px] shrink-0 bg-[#181818]">🏋️</div>
            <div className="flex flex-col">
              <div className="text-[13px] font-medium text-white">Linked gym</div>
              <div className="text-[11px] text-[#888] mt-0.5">Power House GYM, Amalapuram</div>
            </div>
          </div>
          <div className="flex items-center gap-2 shrink-0"><span className="text-[13px] text-[#888]">›</span></div>
        </div>
      </div>

      {/* App preferences */}
      <div className="text-[11px] font-medium text-[#888] uppercase tracking-[0.6px] mt-5 mb-2">App preferences</div>
      <div className="bg-[#101010] border-[0.5px] border-[#2b2b2b] rounded-[12px] overflow-hidden">
        {/* Language */}
        <div
          className="flex items-center justify-between p-3.5 border-b-[0.5px] border-[#2b2b2b] cursor-pointer gap-3 transition-colors hover:bg-[#181818] opacity-60"
          onClick={() => alert("This feature is under development and will be available in a future update.")}
        >
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-[8px] flex items-center justify-center text-[14px] shrink-0 bg-[#181818]">🌐</div>
            <div className="flex flex-col">
              <div className="text-[13px] font-medium text-white">Language</div>
              <div className="text-[11px] text-[#888] mt-0.5">Status: <span className="text-yellow-500 italic font-medium">Coming Soon</span></div>
            </div>
          </div>
          <div className="flex items-center gap-2 shrink-0 opacity-50 cursor-not-allowed">
            <span className="text-[12px] text-[#888]">{selectedLanguage}</span>
            <span className="text-[13px] text-[#888]">›</span>
          </div>
        </div>

        {/* Dark mode */}
        <div
          className="flex items-center justify-between p-3.5 border-b-[0.5px] border-[#2b2b2b] cursor-pointer gap-3 transition-colors hover:bg-[#181818] opacity-60"
          onClick={() => alert("This feature is under development and will be available in a future update.")}
        >
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-[8px] flex items-center justify-center text-[14px] shrink-0 bg-[#181818]">🌙</div>
            <div className="flex flex-col">
              <div className="text-[13px] font-medium text-white">Dark mode</div>
              <div className="text-[11px] text-[#888] mt-0.5">Status: <span className="text-yellow-500 italic font-medium">Coming Soon</span></div>
            </div>
          </div>
          <div className="w-[44px] h-6 rounded-[12px] border-[0.5px] relative transition-colors shrink-0 bg-[#333] border-[#444] opacity-50 cursor-not-allowed">
            <div className="w-[18px] h-[18px] rounded-full bg-gray-500 absolute top-[2px] left-[3px]" />
          </div>
        </div>

        {/* Clear cache */}
        <div className="flex items-center justify-between p-3.5 border-b-[0.5px] border-[#2b2b2b] cursor-pointer gap-3 transition-colors hover:bg-[#181818]">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-[8px] flex items-center justify-center text-[14px] shrink-0 bg-[#181818]">🗑️</div>
            <div className="flex flex-col">
              <div className="text-[13px] font-medium text-white">Clear cache</div>
              <div className="text-[11px] text-[#888] mt-0.5">Free up storage on this device</div>
            </div>
          </div>
          <div className="flex items-center gap-2 shrink-0"><span className="text-[13px] text-[#888]">›</span></div>
        </div>

        {/* App version */}
        <div className="flex items-center justify-between p-3.5 last:border-b-0 cursor-pointer gap-3 transition-colors hover:bg-[#181818]">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-[8px] flex items-center justify-center text-[14px] shrink-0 bg-[#181818]">ℹ️</div>
            <div className="flex flex-col">
              <div className="text-[13px] font-medium text-white">App version</div>
              <div className="text-[11px] text-[#888] mt-0.5">Check for updates</div>
            </div>
          </div>
          <div className="flex items-center gap-2 shrink-0">
            <span className="text-[12px] text-[#888]">v1.0.0</span>
          </div>
        </div>
      </div>

      {/* Language Selection Modal */}
      <div
        className={`fixed inset-0 bg-black/60 z-[100] flex items-end justify-center transition-opacity duration-250 ${isLangModalOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`}
        onClick={(e) => { if (e.target === e.currentTarget) setIsLangModalOpen(false); }}
      >
        <div className={`bg-[#181818] rounded-t-[16px] w-full max-w-[480px] p-5 transition-transform duration-300 ${isLangModalOpen ? 'translate-y-0' : 'translate-y-full'}`}>
          <div className="text-[15px] font-medium text-white mb-4">Select language</div>
          {languages.map((lang) => (
            <div
              className="flex items-center justify-between py-3 border-b-[0.5px] border-[#2b2b2b] last:border-b-0 cursor-pointer transition-opacity hover:opacity-80"
              key={lang.value}
              onClick={() => handleSelectLanguage(lang.value)}
            >
              <span className="text-[14px] text-white">{lang.label}</span>
              <div className={`w-5 h-5 rounded-full border-[0.5px] flex items-center justify-center text-[11px] transition-all ${selectedLanguage === lang.value ? 'bg-[#6CD800] border-[#6CD800] text-black' : 'border-[#2b2b2b] text-transparent'}`}>
                {selectedLanguage === lang.value ? '✓' : ''}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SettingsScreen;
